import React, { useEffect, useState } from 'react'
import { Button, Col, Drawer, Form, Icon, notification, Row, Tooltip, Card, Input, DatePicker } from 'antd'
import { connect } from 'react-redux'
import { singleReceivedCommissionFxn, commissionEditReceivedFxn, commissionReceiveNewFxn } from '../actions'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import lodash from 'lodash'
import CommissionListDrawer from './commissionListDrawer'
import { CustomInput, getcurrencySymbols } from '../../../components/_utils/appUtils'


const SingleCommissionCard =
  ({
     item,
     receivedCommissionId,
     onSubmit, onClose,
     currency, commissionList, setCommissionList
   }) => {
    let dispatch = useDispatch()
    let [bonus, setBonus] = useState(item.agentBonus || 0)
    let [agentCommission, setAgentCommission] = useState(item.agentCommission || 0)
    let [invoiceDate, setInvoiceDate] = useState(moment(item.agentCommissionRaisedDate) || null)
    let [studentCommissionState, setStudentCommission] = useState({
      studentCommission: item.amount,
      id: ''
    })

    const updateRecord = (data) => {
      let commissionListTemp = lodash.clone(commissionList)
      let findCom = lodash.find(commissionListTemp, (item) => {
        return item._id == data._id
      })
      if (findCom) {
        findCom.studentCommission = data.studentCommissionState ? parseFloat(data.studentCommissionState) : parseFloat(data.studentCommission)
        setCommissionList(commissionListTemp)
      }
    }


    const handleStatusUpdate = async (item) => {
      let commissions = [{
        commissionId: item._id,
        studentCommission: studentCommissionState.studentCommission,
        invoiceDate: invoiceDate
      }]
      let valData = {}
      if (!studentCommissionState.studentCommission) {
        notification.warning({
          message: 'Please Enter Student Commission'
        })
        return
      }
      if (!invoiceDate) {
        notification.warning({
          message: 'Please Choose Invoice Date'
        })
        return
      }
      if (!agentCommission) {
        notification.warning({
          message: 'Please Enter Agent Commission'
        })
        return
      }
      valData.commissions = commissions
      valData.receivedAmount = studentCommissionState.studentCommission
      valData.currency = currency

      /* if (record.currency == 'INR') {
         valData.receivedAmountInInr = amountState.receivedAmountInInr
       } else {
         let receivedAmountInInr = parseFloat(studentCommissionState.studentCommission) * parseFloat(valData.currencyRate)
         valData.receivedAmountInInr = receivedAmountInInr
       }*/
      /*if (totalCommission !== studentCommissions && !valData.details) {
        notification.warning({
          message: 'Your Total Commission & individual Student Commission are mismatch. Please Enter reason in details column to proceed!'
        })
        return
      }*/
      valData.receivedCommissionId = receivedCommissionId
      valData.invoiceDate = invoiceDate

      if (agentCommission) {
        valData.agentCommission = parseFloat(agentCommission)
      }
      if (bonus) {
        valData.bonus = parseFloat(bonus)
      }

      let resp = await dispatch(commissionReceiveNewFxn(valData))
      if (resp && resp.success) {
        onSubmit()
        onClose()
      }
    }


    useEffect(() => {
      if (studentCommissionState.studentCommission && studentCommissionState.id) {
        updateRecord({
          studentCommissionState: studentCommissionState.studentCommission,
          _id: studentCommissionState.id
        })
      }
    }, [studentCommissionState.studentCommission])


    return (
      <>
        <div className={`commissionParentBox`}>
          <Card className={'commissionUniInfo'}>
            {item && item.universityId && item.universityId.universityName ?
              <div className={'row'}>
                <div className={'studentBox flexStart'} style={{ width: '20%' }}>
                  <div className={'studentInfo'} style={{ paddingLeft: 10 }}>
                    <div className={'uniName'}>
                      {item.courseName}
                    </div>
                    <div className={'courseInfo'}>
                      <b>Student Name:</b> {item.name}
                    </div>
                    {
                      item && item.commissionDetails && item.commissionDetails ?
                        <div className={'flexRow'}>
                          <div className={'courseInfo'}>
                            <b>Student ID </b>: {item.commissionDetails.offerLetterStudentId}
                          </div>
                          <span>|</span>
                          <div className={'courseInfo'}>
                            <b>App ID</b>: {item.appId}
                          </div>
                        </div> : null
                    }
                  </div>
                </div>
                <div className={'studentBox flexStart'} style={{ width: '20%' }}>
                  <div className={'studentInfo'}>
                    <div className={'uniName'}> {item.semester}
                    </div>
                    <div className={'courseInfo'}>
                      Semester Fees : {item.semesterFee} {item.currency}
                    </div>
                    <div className={'courseInfo'}>
                      Offer S. ID : {item.commissionDetails.offerLetterStudentId}
                    </div>
                  </div>
                </div>
                <div className={'studentBox flexStart'} style={{ width: '30%' }}>
                  <div className={'studentInfo'}>
                    <div className={'uniName'}><h6>Received Commission</h6>
                      <div className='receive-commission-box'>
                        <div className='receive-commission'>
                          <CustomInput
                            disabled={item.status == 'Received'}
                            type='text'
                            leftContent={currency}
                            className='input-amount'
                            label={true}
                            title='Amount'
                            value={studentCommissionState.studentCommission}
                            onChange={(value) => {
                              setStudentCommission({
                                studentCommission: value
                              })
                            }}
                          />
                        </div>
                        <div className='receive-commission-new-date'>
                          <DatePicker
                            disabled={item.status == 'Received'}
                            type='date'
                            name='dateOfBirth'
                            className='form-control'
                            placeholder='Date '
                            value={invoiceDate}
                            onChange={(val) => {
                              setInvoiceDate(val)
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={'studentBox flexStart'} style={{ width: '30%' }}>
                  <div className='studentInfo'>
                    <div className='uniName agent-commission'>
                      <h6>Agent Commission
                      </h6>

                      <div className='receive-commission-box'>
                        <div className='receive-commission'>
                          <CustomInput
                            disabled={item.status == 'Received'}
                            type='text'
                            leftContent={currency}
                            className='input-amount'
                            label={true}
                            title='Amount'
                            placeholder='Amount'
                            value={agentCommission}
                            onChange={(value) => {
                              setAgentCommission(value)
                            }}
                          />
                        </div>
                        <div className='receive-commission'>
                          <CustomInput
                            leftContent={currency}
                            disabled={item.status == 'Received'}
                            type='text'
                            className='input-amount'
                            title='Bonus'
                            label={true}
                            value={bonus}
                            onChange={(value) => {
                              setBonus(value)
                            }}
                          />
                        </div>
                      </div>

                    </div>

                    {item.status != 'Received' ?
                      <Col span={24}>
                        <Form.Item>
                          <Col span={24}>
                            <Form.Item>
                              <div className='receive-btn'>
                                <Button type='primary' htmlType='submit' onClick={() => {
                                  handleStatusUpdate(item)
                                }}>
                                  Receive
                                </Button>
                                <Button type='primary' htmlType='submit'>
                                  Cancel
                                </Button>
                              </div>
                            </Form.Item>
                          </Col>
                        </Form.Item>
                      </Col> :
                      <label className={'label label-success-green mt20'}>Received And Raised ✔️</label>
                    }

                  </div>
                </div>
              </div> : null}
          </Card>
        </div>
      </>
    )
  }


let initState = {
  visible: false,
  selectedCommissions: []
}
let amountInit =
  {
    receivedAmount: '',
    receivedAmountInInr: ''
  }
const NewClaimReceivedDrawerComponent = (props) => {
  let dispatch = useDispatch()
  let {
    visible,
    onClose,
    onSubmit,
    form: { setFieldsValue },
    record
  } = props
  let { currency } = record
  let commissionId = record._id
  let [commissionList, setCommissionList] = useState([])
  let [amountState, setAmountState] = useState(amountInit)
  let [receivedCommissionId, setReceivedCommissionId] = useState('')
  let [universityInvoice, setUniversityInvoice] = useState(null)
  let [state, setState] = useState(initState)

  useEffect(() => {
    setTimeout(() => {
      setFieldsValue({ claimReceivedDate: moment() })
    }, 300)
    loadReceiveCommission()
  }, [])

  useEffect(() => {
    reCalculateAmount()
  }, [commissionList])

  const loadReceiveCommission = async () => {
    let { receivedCommissionId } = record
    let { success, data } = await dispatch(singleReceivedCommissionFxn({ commissionId: receivedCommissionId }))
    if (success) {
      setCommissionList(data.commissionList)
      setReceivedCommissionId(data._id)
      if (data && data.universityInvoice && data.universityInvoice.url) {
        setUniversityInvoice(data.universityInvoice)
      }
    }
  }

  let reCalculateAmount = () => {
    let totalAmount = 0
    lodash.each(commissionList, (item) => {
      totalAmount = parseFloat(totalAmount) + (item.studentCommission ? parseFloat(item.studentCommission) : parseFloat(item.studentCommission))
    })
    if (record.currency == 'INR') {
      setAmountState({
        ...amountState,
        receivedAmountInInr: parseFloat(totalAmount)
      })
    } else {
      setAmountState({
        ...amountState,
        receivedAmount: parseFloat(totalAmount)
      })
    }
  }

  const events = {
    showVisibleCommission: () => {
      let selectedCommissions = []
      lodash.each(commissionList, (item) => {
        selectedCommissions.push(item._id)
      })
      setState({
        ...state,
        visible: true,
        selectedCommissions
      })
    },
    hideVisibleCommission: () => {
      setState({
        ...state,
        visible: false
      })
    },
    chooseCommission: (data) => {
      let commissionListTemp = lodash.clone(commissionList)
      let findCom = lodash.find(commissionListTemp, (item) => {
        return item._id == data._id
      })
      if (findCom) {
        notification.warning({ message: 'Commission already exists.' })
      } else {
        commissionListTemp.push(data)
        setCommissionList(commissionListTemp)
      }
    },
    removeStu: (commissionId) => {
      let commissionListTemp = lodash.clone(commissionList)
      commissionListTemp = lodash.reject(commissionListTemp, (item) => {
        return item._id == commissionId
      })
      setCommissionList(commissionListTemp)
    },
    updateRecord: (data) => {
      let commissionListTemp = lodash.clone(commissionList)
      let findCom = lodash.find(commissionListTemp, (item) => {
        return item._id == data._id
      })
      if (findCom) {
        findCom.studentCommission = data.studentCommissionState ? parseFloat(data.studentCommissionState) : parseFloat(data.studentCommission)
        setCommissionList(commissionListTemp)
      }
    }
  }

  return (
    <>
      <Drawer
        visible={visible}
        onClose={onClose}
        title={`Receive Commission`}
        width={'92%'}>
        <div className='form-box commissionBox'>
          <div className='card unizportal'>
            <Row gutter={16} className={'wrapBox'}>
              <Col span={6}>
                <div className={`universityParentBox`}>
                  <Card className={'commissionUniInfo'}>
                    {record && record.universityId.universityName ?
                      <>
                        {record && record.universityId ?
                          <div className={'uniLogo'}>
                            <img
                              src={record && record.universityId && record.universityId.logo && record.universityId.logo.url ? record.universityId.logo.url : ''} />
                          </div> : null}
                        <div className={'studentInfoBox'}>
                          <div className={'uniName'}>
                            {record.universityId.universityName}
                          </div>
                        </div>
                      </>
                      : null}
                  </Card>
                </div>
              </Col>

              <Col span={9}>
                <Card>
                  <div className='card-row'>
                    <p className='commission-label-new'><b>Invoice Number</b></p>
                    <p className='commission-value-new'>{record.invoiceNumber}</p>
                  </div>
                  <div className='card-row'>
                    <p className='label-new'><b>University Of Statement</b></p>
                    <div className='value-new file-preview'>
                      {record.universityInvoice.url ? (
                        <>

                          <img src='../images/google-docs.png' alt='DOC'
                               className='doc-card-icon' />
                          <a
                            href={record.universityInvoice.url}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='file-link'
                          >
                          </a>
                        </>
                      ) : (
                        <span>No file uploaded</span>
                      )}
                    </div>
                  </div>

                  <div className='card-row'>
                    <p className='label-new'><b>Claim Receive Date</b></p>
                    <p className='value-new'>
                      {moment(record.claimReceivedDate).format('MMM DD, YYYY')}
                    </p>
                  </div>
                  <div className='card-row'>
                    <p className='label-new'><b>Total Students</b></p>
                    <p className='value-new'>{record.totalStudents}</p>
                  </div>
                </Card>

              </Col>
              <Col span={9}>
                <Card>
                  <div className='card-row'>
                    <p className='commission-label-new'><b>Total Commission</b></p>
                    <p
                      className='commission-value-new-total'>{getcurrencySymbols[record.currency]}{record.totalCommission}</p>
                  </div>
                  <div className='card-row'>
                    <p className='label-new'><b>Pending Amount</b></p>
                    <p className='commission-value-new-pending'>
                      {getcurrencySymbols[record.currency]}{record.totalCommission}
                    </p>
                  </div>
                  <div className='card-row'>
                    <p className='commission-value-new-receive'><b>Receive Commission</b></p>
                    <p className='value-new'>
                      0
                    </p>
                  </div>
                  <div className='card-row'>
                    <p className='label-new'><b>Agent Commission</b></p>
                    <p className='value-new'>0</p>
                  </div>
                </Card>

              </Col>
            </Row>

            <Form>
              <Row gutter={16} className={'wrapBox'}>

                <Col span={18}>

                </Col>
                <Col span={24}>
                  <div className={'commissionListBox'}>
                    {commissionList && commissionList.length > 0
                      ? commissionList.map((item, index) => {
                        return (
                          <SingleCommissionCard
                            key={index}
                            item={item}
                            amountState={amountState}
                            receivedCommissionId={receivedCommissionId}
                            onSubmit={onSubmit}
                            onClose={onClose}
                            currency={currency}
                            record={record}
                            commissionList={commissionList}
                            setCommissionList={setCommissionList}
                          />
                        )
                      })
                      : null}
                  </div>
                </Col>
                {/*<Col span={4}>*/}
                {/*  <Form.Item>*/}
                {/*    <Button*/}
                {/*      type="primary" htmlType="submit" className={'btn mt40'}>*/}
                {/*      Receive Commission*/}
                {/*    </Button>*/}
                {/*  </Form.Item>*/}
                {/*</Col>*/}
              </Row>
            </Form>

          </div>
        </div>
        {state.visible ?
          <CommissionListDrawer
            record={record}
            commissionId={commissionId}
            selectedCommissions={state.selectedCommissions}
            onClose={events.hideVisibleCommission}
            onSubmit={events.chooseCommission}
            status={'Commission Claimed'}
            visible={state.visible} />
          : null}
      </Drawer>
    </>
  )
}

const NewClaimReceivedDrawer = Form.create()(NewClaimReceivedDrawerComponent)
const mapStateToProps = ({ global, router }) => ({
  currentUser: global.currentUser
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewClaimReceivedDrawer)


//NewCommissionFlow
